import { mobileStartActionByUrl, mobileStartFlutterActionByUrl } from "../Scripts";
import { setUrlTo } from "../../components/FormsV2/GeneralScripts";

export const handleProcessAction = (actionInfo, recordId) => {
   const searchParams = new URLSearchParams({
      processId: actionInfo.processId,
      recordId,
   });
   const targetPath = `/cases/${actionInfo.processId}?${searchParams.toString()}`;

   mobileStartActionByUrl(targetPath);
   mobileStartFlutterActionByUrl("startActionByUrl", targetPath);
   setUrlTo(targetPath);
};
